module.exports = __webpack_public_path__ + "img/icon-select-checked.9e67f5d3.svg";